import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['canvas', 'legend', 'tooltip']

  static values = {
    builder: String,
    chartType: String,
    chartOptions: Object
  }

  connect() {
    return this.#buildChart()
  }

  disconnect() {
    return this.#destroyChart()
  }

  setChartTypeAndRebuildChart(chartType) {
    this.chartTypeValue = chartType
    this.#buildChart()
  }

  async #buildChart() {
    this.#destroyChart()
    this.chart = await this.#importBuilder().then(build => {
      return build(
        this.chartTypeValue,
        this.canvasTarget,
        this.legendTarget,
        this.tooltipTarget,
        this.chartOptionsValue
      )
    })
  }

  #destroyChart() {
    if (Object.hasOwn(this, 'chart')) {
      this.chart.destroy()
      delete this.chart
    }
  }

  async #importBuilder() {
    return import(`~/charts/builders/${this.builderValue}.js`).then(({ default: build }) => build)
  }
}
